import { Button, Divider } from '@components';
import { formatWithNumberMask, formatWithPhoneMask } from '@core';
import { layoutsStore } from '@layouts';
import { routes } from '@router';
import { useCurrentUser } from '@user';
import { Logo, NavSidebar } from '@widgets';
import { useLocation } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import styles from './styles.module.scss';

export const BalancePanel = () => {
  const { full_name, phone, balance } = useCurrentUser();
  const { pathname } = useLocation();
  const isRefillButtonDisabled = pathname.includes(routes.dashboard.sub.balance.path);
  const setRefillSidebarVisible = useSetRecoilState(layoutsStore.refillSidebarVisibleState);

  const onRefillBalanceClick = () => {
    setRefillSidebarVisible(true);
  };

  return (
    <div className={styles.card}>
      <Logo withTitle isLink />
      <Divider className="mt-3 mb-extra1 hidden landscape-tablet:block" />
      <h4 className="text-lg font-medium mb-1 hidden landscape-tablet:block">{full_name}</h4>
      <span className="text-sm text-third hidden landscape-tablet:block">
        {formatWithPhoneMask(phone)}
      </span>
      <Divider className="my-extra1 hidden landscape-tablet:block" />
      <span className="text-sm text-third hidden landscape-tablet:block">Ваш баланс:</span>
      <h1 className="text-3xl desktop:text-4xl line-height-2 font-semibold mb-extra2 hidden landscape-tablet:block">
        {formatWithNumberMask(balance, false, true)}
      </h1>
      <Button
        label="Пополнить"
        data-testid="refillBalance"
        className="p-button-help align-self-start hidden landscape-tablet:block"
        disabled={isRefillButtonDisabled}
        onClick={onRefillBalanceClick}
      />
      <NavSidebar className="landscape-tablet:hidden" menuClassName="ml-auto" />
    </div>
  );
};
